import React from "react";
import { WebTradingTerminalContext } from "features/tradingTerminal/WebTradingTerminal.context";
import OldTradingTerminal from "features/tradingTerminal/Layouts/OldTradingTerminal";
import NewTradingTerminal from "features/tradingTerminal/Layouts/NewTradingTerminal";
import useWebTradingTerminalProvider from "features/tradingTerminal/useWebTradingTerminalProvider";
import NoExchangeConnectedModal from "features/configuration/common/NoExchangeConnectedModal";
import QueriesError from "common/Empty/QueriesError";

const WebTradingTerminalProvider = () => {
  const {
    sectionToComponent,
    trailingComponent,
    trailingModifiedConfiguration,
    useTradingTerminalOldVersion,
    noExchangeModalVisible,
    setNoExchangeModalVisible,
    isError,
    refetchErrorQueries,
  } = useWebTradingTerminalProvider();

  return (
    <WebTradingTerminalContext.Provider
      value={{
        sectionToComponent,
        trailingComponent,
        trailingModifiedConfiguration,
      }}
    >
      {isError ? (
        <QueriesError refetchErrorQueries={refetchErrorQueries} />
      ) : useTradingTerminalOldVersion ? (
        <OldTradingTerminal />
      ) : (
        <NewTradingTerminal />
      )}
      <NoExchangeConnectedModal
        placement="trading_terminal"
        open={noExchangeModalVisible}
        onClose={() => setNoExchangeModalVisible(false)}
        action="create a trade"
      />
    </WebTradingTerminalContext.Provider>
  );
};

export default WebTradingTerminalProvider;
